<template>
  <div
    id="histogramMain"
    :style="{ height: height, width: width }"
  ></div>
</template>


<script>
const utils = require("@/api/core/utils");
// const dao = require('@/api/core/dao');
import * as echarts from "echarts";

export default {
  name: "yes-histogram",
  props: {
    formCreateInject: {
      type: Object,
      required: true,
    },
    dataSource: String,
    //x轴字段(1月，2月，3月....)
    xField: {
      type: String,
      default: "",
    },
    yField: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "histogram",
    },
    showTooltip: {
      type: Boolean,
      default: true,
    },
    marginTop: {
      type: String,
      default: "10%",
    },
    marginLeft: {
      type: String,
      default: "3%",
    },
    marginRight: {
      type: String,
      default: "3%",
    },
    marginBottom: {
      type: String,
      default: "3%",
    },
    canSaveImage: {
      type: Boolean,
      default: true,
    },
    height: {
      type: String,
      default: "100%",
    },
    width: {
      type: String,
      default: "100%",
    },
    barWidth: {
      type: String,
      default: "50%",
    },
  },
  data () {
    return {
      viewData: [],
      pieData: [],
      xAxis_data: [],
      yAxis_data: [],
      fDataSource: this.dataSource
    };
  },
  watch: {
    viewData () {
      this.parse();
    },
  },
  // created() {
  //   this.initEcharts();
  // },
  methods: {
    // 方法
    initEcharts () {
      // 基于准备好的dom，初始化echarts实例

      // 新建一个promise对象
      let newPromise = new Promise((resolve) => {
        resolve();
      });
      //然后异步执行echarts的初始化函数
      newPromise.then(() => {
        //	此dom为echarts图标展示dom
        var myChart = echarts.init(document.getElementById("histogramMain"));
        // 绘制图表
        myChart.setOption({
          title: {
            text: this.title,
            left: "center",
          },
          tooltip: {
            show: this.showTooltip,
            trigger: "axis",
            axisPointer: {
              type: "shadow",
            },
          },
          xAxis: {
            //默认x轴类型
            type: "category",
            data: this.xAxis_data,
          },
          yAxis: {
            //默认y轴类型
            type: "value",
          },
          grid: {
            top: this.marginTop,
            left: this.marginLeft,
            right: this.marginRight,
            bottom: this.marginBottom,
            //containLabel 为 true 的时候：
            // grid.left grid.right grid.top grid.bottom grid.width grid.height 决定的是包括了坐标轴标签在内的所有内容所形成的矩形的位置。
            // 这常用于『防止标签溢出』的场景，标签溢出指的是，标签长度动态变化时，可能会溢出容器或者覆盖其他组件。
            containLabel: true,
          },
          toolbox: {
            show: this.canSaveImage,
            feature: {
              //保存图片
              saveAsImage: {},
            },
          },
          //   legend: {
          //     left: "left",
          //   },
          series: [
            {
              type: "bar",
              barWidth: this.barWidth,
              data: this.yAxis_data,
            },
          ],
        });
      });
    },
    // 将组件的值返回
    getValue () {
      //   return this.href;
    },
    // 修改组件的值
    setValue () {
      //   this.href = val;
    },
    // 读取绑定数据源数据
    loadSourceData () {
      let da = utils.getSourceData(this.fDataSource);
      this.viewData = da !== undefined ? da : this.data;
    },
    parse () {
      this.viewData.forEach((item) => {
        this.xAxis_data.push(item[this.xField]);
        this.yAxis_data.push(item[this.yField]);
      });
      this.initEcharts();
    },
    // 修改绑定数据源数据
    updateSourceData () { },
  },
};
</script>
<style scoped>
</style>
